<template>
  <div class="nav-wrapper">
    <nav class="nav">
      <router-link class="nav-logo" to="/"></router-link>
      <div class="nav-list">
        <router-link
          class="nav-list-item"
          :class="[
            index === 0 ? 'first-item' : '',
            $route.path.indexOf(item.path) === 0 ||
            ($route.path.indexOf('/about-us')===0 &&
              item.path.indexOf('/about-us')===0)
              ? 'nav-list-item--active'
              : ''
          ]"
          :to="item.path"
          v-for="(item, index) in array"
          :key="index"
          >{{ item.name }}</router-link
        >
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  data() {
    return {
      array: [
        {
          path: "/about-us/brief",
          name: this.$t("About Us")
        },
        {
          path: "/productions",
          name: this.$t("Productions")
        },
        {
          path: "/theatres",
          name: this.$t("Theatres")
        },
        {
          path: "/contact-us",
          name: this.$t("Contact Us")
        }
      ]
    };
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.nav-wrapper {
  width: 100%;
  height: 92px;
  background-color: #fefefe;
  line-height: 92px;
  text-align: center;
}
.nav {
  width: 1200px;
  display: inline-block;
  position: relative;
  text-align: left;
  a {
    cursor: pointer;
  }
  &-logo {
    width: 172px;
    height: 54px;
    display: inline-block;
    background-image: url("../assets/logo.png");
    background-size: 100% 100%;
    vertical-align: middle;
  }
  &-list {
    display: inline-block;
    vertical-align: middle;
    &-item {
      margin-left: 39px;
      font-size: 18px;
      font-weight: bold;
      color: rgba(46, 41, 37, 1);
      vertical-align: middle;
      &--active {
        color: #ec6900;
      }
    }
  }
  &-ticket {
    width: 138px;
    height: 50px;
    background: #fff5ec;
    float: right;
    margin-top: 21px;
    vertical-align: middle;
    line-height: 50px;
    color: #ff9306;
    &-icon {
      vertical-align: middle;
      font-size: 22px;
      display: inline-block;
      transform: rotate(15deg);
      margin-left: 20px;
    }
    &-text {
      vertical-align: middle;
      margin-left: 9px;
    }
  }
}
.first-item {
  margin-left: 50px;
}
</style>